import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-upload",
  templateUrl: "./med-icon-upload.component.html",
})
export class MedIconUploadComponent extends SvgMixinComponent {}
